interface ArrowProps {
    direction?: 'up' | 'down' | 'left' | 'right';
    className?: string;
    color?: string;
    strokeWidth?: number;
}

export default function Arrow({ 
    direction = 'down',
    className = "w-6 h-6", 
    color = "currentColor",
    strokeWidth = 4
}: ArrowProps) {
    // Rotation angles for each direction
    const rotations = {
        down: 0,
        up: 180,
        left: 90,
        right: -90
    };

    return (
        <svg 
            className={className}
            viewBox="0 0 48 48" 
            fill="none" 
            xmlns="http://www.w3.org/2000/svg"
            style={{ transform: `rotate(${rotations[direction]}deg)` }}
        >
            <path 
                d="M24 36V12" 
                stroke={color}
                strokeWidth={strokeWidth}
                strokeLinecap="round" 
                strokeLinejoin="round"
            />
            <path 
                d="M32 28L24 36L16 28" 
                stroke={color}
                strokeWidth={strokeWidth}
                strokeLinecap="round" 
                strokeLinejoin="round"
            />
        </svg>
    );
}

